/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_SyncInputs */



/**
* | output |
* | --- |
* | "Offline Sync" |
*
* @param {Offline_SyncInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_sync = /** @type {((inputs?: Offline_SyncInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_SyncInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Synchronisation hors ligne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Offline-Synchronisierung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sincronizzazione offline")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Оффлайн-синхронизация")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sincronización sin conexión")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("离线同步")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オフライン同期")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑफलाइन सिंक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sincronização offline")
	return /** @type {LocalizedString} */ ("Offline Sync")
});